import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isAuthenticated: false,
  token: null,
  profile: null,
  userUid: null,
  commonServiceToken: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthData: (state, action) => {
      state.isAuthenticated = true;
      state.token = action.payload.token;
      state.profile = action.payload.profile;
      state.userUid = action.payload.userUid;
      state.commonServiceToken = action.payload.commonServiceToken;
    },
    clearAuthData: (state) => {
      state.isAuthenticated = false;
      state.token = null;
      state.profile = null;
      state.userUid = null;
      state.commonServiceToken = null;
    },
  },
});

export const { setAuthData, clearAuthData } = authSlice.actions;
export default authSlice.reducer;
